import React, { useEffect, useState } from 'react';
import { useAppSelector, useAppDispatch } from '../../../../app/hooks';
import { IPaginationPayload } from '../../../../interfaces/shared/IPaginationPayload';
import { tryToFetchGuestAllBooking } from '../../../../store/brokers/partner/guests/guestsSlice';
import GuestBookingHistory from '../GuestBookingHistory';

interface IReservationHistory {
    id: string;
}

const ReservationHistory = ({
    id
}: IReservationHistory) => {
    const dispatch = useAppDispatch();
    const [rows, setRows] = useState<Array<any>>([]);
    const [paginationState, setPaginationState] = useState<IPaginationPayload>({
        pageNumber: 1,
        pageSize: 10,
    });
    const paginationData = useAppSelector((state) => state?.guests?.guestReservations?.data?.page);
    const guestsLoading = useAppSelector((state) => state.guests.guestReservationsLoading);
    const state = useAppSelector((state) => state.guests);


    const onGettingGuestsData = async () => {
        try {
            const fetchData = {
                ...paginationState || {},
                id: id
            }
            await dispatch(tryToFetchGuestAllBooking(fetchData)).unwrap()
        } catch (err) {
            // err
        }
    }

    useEffect(() => {
        onGettingGuestsData()
    }, [paginationState, id])

    useEffect(() => {
        if (state.guestReservations) {
            const rows = state.guestReservations?.elements
            setRows(rows);
        }
    }, [state.guestReservations]);

    return (
        <div className='my-10'>
            <GuestBookingHistory
                rows={rows}
                rowsLoading={guestsLoading}
                paginationData={paginationData}
                setPaginationState={setPaginationState}
            />
        </div>
    )
}
export default ReservationHistory;